import { useContext, useState, useEffect, useMemo } from "react";
import { BlocksValue } from "../contexts/blocks";

export default function () {
  const [containers, setContainers] = useState([]);
  const [overlays, setOverlays] = useState([]);
  const blocks = useContext(BlocksValue);

  useEffect(() => {
    if (blocks) {
      const containers = blocks
        .filter(
          (x) =>
            x.type === "container" ||
            x.type === "page" ||
            x.type === "overlay" ||
            x.type === "data"
        )
        .map((x) => x.name);

      setContainers(containers);
    }

    const overlays = blocks
      .filter((x) => x.type === "overlay")
      .map((x) => x.name);
    setOverlays(overlays);
  }, [blocks]);

  return { containers, overlays };
}
